/*
 | -------------------------------------------------------------
 |  --> type: component
 |  --> name: responsive toggler
 | -------------------------------------------------------------
 |
 |  Functionality for responsive togglers.
 |
*/

/* -------------------------------------------------------------
 | variables
 | -------------------------------------------------------------
 */

const responsiveTogglers = [...document.querySelectorAll('.mgbdes__responsive-toggler')]

/* -------------------------------------------------------------
 | functions
 | -------------------------------------------------------------
 */

const closeResponsiveToggler = responsiveToggler => {
  const responsiveTogglerButton = responsiveToggler.querySelector('button')
  responsiveToggler.classList.remove('open')

  // return focus to parent element on close
  // responsiveTogglerButton.focus()

  // set aria expanded false on closing current button
  responsiveTogglerButton.setAttribute('aria-expanded', false)
}

const openResponsiveToggler = responsiveToggler => {
  const responsiveTogglerButton = responsiveToggler.querySelector('button')

  responsiveToggler.classList.add('open')

  // set aria expanded true on opening current button
  responsiveTogglerButton.setAttribute('aria-expanded', true)
}

const isResponsiveTogglerOpen = responsiveToggler => {
  return responsiveToggler.classList.contains('open')
}

/* -------------------------------------------------------------
 | execution
 | -------------------------------------------------------------
 */

// add click event
// check if a toggle card is present on page, if yes, loop through each single toggle card
responsiveTogglers && responsiveTogglers.forEach(responsiveToggler => {
  const toggleButton = responsiveToggler.querySelector('.responsive-toggler__button')
  toggleButton.addEventListener('click', event => {
    isResponsiveTogglerOpen(responsiveToggler)
      ? closeResponsiveToggler(responsiveToggler)
      : openResponsiveToggler(responsiveToggler)
  })
})
